import { render } from "./EquipeView.vue?vue&type=template&id=4cbda754&scoped=true"
import script from "./EquipeView.vue?vue&type=script&lang=js"
export * from "./EquipeView.vue?vue&type=script&lang=js"

import "./EquipeView.vue?vue&type=style&index=0&id=4cbda754&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cbda754"]])

export default __exports__